const BATCH_SIZE = 20
const BATCH_DELAY = 50 // in ms

export const createBatchQueue = <T>(promise: (ids: string[]) => Promise<Record<string, T>>) => {
  type Result = Record<string, T>
  let timer: ReturnType<typeof setTimeout> | null = null
  let resolvers: ((value: Result) => void)[] = []
  let queue: string[] = []

  const flushQueue = () => {
    const ids = [...queue]
    const currentResolvers = [...resolvers]
    queue = []
    resolvers = []
    timer = null
    if (ids.length === 0) {
      return
    }
    promise(ids).then((result) => {
      currentResolvers.forEach((resolve) => resolve(result))
    })
  }

  const addToQueue = (id: string): Promise<Result> => {
    return new Promise((resolve) => {
      queue.push(id)
      resolvers.push(resolve)
      if (queue.length >= BATCH_SIZE) {
        flushQueue()
      } else if (!timer) {
        timer = setTimeout(flushQueue, BATCH_DELAY)
      }
    })
  }
  return {
    addToQueue,
  }
}
